<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title">Данные об ущербе</h3>
      <RoomBlock v-for="room in roomsCount" :key="room" :index="room" v-model="roomsFilled[room]" />
      <RadioGroup :required="true" title="Повреждено движимое имущество?" :values="['Да', 'Нет']"
        :name="`damagedata-moving_damaged`" v-model="form.damagedata.moving_damaged"
        :class="{ 'mb20': dynamicfields.moving }" />
      <MovingList class="mb40" v-model="listsfilled.moving" v-if="dynamicfields.moving"
        :dataArray="form.damagedata.moving" />
      <RadioGroup :required="true" title="Повреждено инженерное оборудование?" :values="['Да', 'Нет']"
        :name="`damagedata-engineer_damaged`" v-model="form.damagedata.engineer_damaged"
        :class="{ 'mb20': dynamicfields.engineer }" />
      <EngineerList class="mb40" v-model="listsfilled.engineer" v-if="dynamicfields.engineer"
        :dataArray="form.damagedata.engineer" />
      <Btn class="step__next" :disabled="!filled" @click.stop.prevent="CheckExtsAndGoNext">Далее</Btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Btn from '@/components/Btn.vue';
import RoomBlock from './RoomBlock.vue';
import MovingList from './MovingList.vue';
import EngineerList from './EngineerList.vue';
import RadioGroup from '@/components/inputs/RadioGroup.vue';

export default {
  components: { Btn, RoomBlock, MovingList, EngineerList, RadioGroup },
  data: () => ({
    roomsFilled: {},
    listsfilled: {
      moving: false,
      engineer: false
    }
  }),
  props: {
    active: { type: Boolean }
  },
  methods: {
    async CheckExtsAndGoNext() {
      try {
        let exts = new Set()
        for (let key in this.extra.fileExts)
          exts.add(...this.extra.fileExts[key])
        exts = Array.from(exts)
        let res = await this.$store.dispatch('sendExts', exts.map(el => el.toLowerCase()))
        if (res === false) {
          return this.$store.dispatch('showErrorPopup', {
            title: 'Ошибка!',
            text: 'Попробуйте повторить запрос',
            button: 'Повторить',
            action: this.CheckExtsAndGoNext
          })
        }
        let forbidden = []
        for (let i = 0; i < res.length; i++)
          if (res[i])
            forbidden.push(exts[i])
        forbidden = Array.from(new Set(forbidden))
        this.extra.forbiddenFileExts = forbidden
        if (this.extra.forbiddenFileExts.length) {
          return this.$store.dispatch('showErrorPopup', {
            title: 'Ошибка!',
            text: 'Некоторые файлы имеют недопустимый формат',
            button: 'Ок',
          })
        }
      } catch (err) {
        console.error(err)
        return this.$store.dispatch('showErrorPopup', {
          title: 'Ошибка!',
          text: 'Попробуйте повторить запрос',
          button: 'Повторить',
          action: this.CheckExtsAndGoNext
        })
      }
      this.$store.commit('nextStep')
    }
  },
  computed: {
    ...mapState(['form', 'extra']),
    roomsCount() {
      return parseInt(this.form.damagedata.roomcount) || 0
    },
    dynamicfields() {
      let obj = {}
      if (this.form.damagedata.moving_damaged.toLowerCase().trim() == 'да')
        obj.moving = true
      if (this.form.damagedata.engineer_damaged.toLowerCase().trim() == 'да')
        obj.engineer = true
      return obj
    },
    filled() {
      for (let i = 1; i <= this.roomsCount || 0; i++)
        if (!this.roomsFilled[i]) {
          return false
        }
      for (let key in this.dynamicfields)
        if (this.dynamicfields[key] && !this.listsfilled[key]) {
          return false
        }
      return true
    },
  },
}
</script>

<style lang="sass">

</style>